export enum ActionType {
  LogOut = "LOG_OUT",
  SetCurrentUser = "SET_CURRENT_USER",
}

export interface LogOutAction {
  type: ActionType.LogOut;
}
export const logOut = (): LogOutAction => ({
  type: ActionType.LogOut,
});

export interface SetCurrentUserAction {
  type: ActionType.SetCurrentUser;
  payload: User;
}
export const setCurrentUser = (user: User): SetCurrentUserAction => ({
  type: ActionType.SetCurrentUser,
  payload: user,
});
